module.exports = __webpack_public_path__ + "e59c9012845ec162c1d15a249e954990.svg";